import { FormEvent, useEffect, useState } from 'react';
import { ExperienceForm } from '@components/templates/resume/forms/ExperienceForm';
import { FooterButtons } from '@components/templates/job/after-apply/FooterButtons';
import { useBjForm } from '@hooks/useBjForm';
import { useSwrResumeNoExperience } from '@hooks/useSwrApi/endpoints/resume/useSwrResumeNoExperience';
import { Input, Label, RadioText } from '@components/common/Forms';
import { useTranslation } from 'next-i18next';

interface IProps {
  onSaveSuccess: () => void,
  noExpAction: () => void,
  locale: Locale,
}

/**
 * @description Experience form with: job title, company, startDate, endDate
 * @param onSaveSuccess - when form is submitted with success
 * @param onSkip - on skip form
 * @param locale - the current app locale
 */
export const Experience = ({ onSaveSuccess, noExpAction, locale }: IProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { t } = useTranslation('common');

  const {
    record, elementsRefs, formStatus, checkFormValidation, postFormData,
  } = useBjForm();

  useEffect(() => {
    if (formStatus.actionStatus === 'error') {
      setIsLoading(false);
    }
    if (formStatus.actionStatus === 'success') {
      onSaveSuccess();
      setIsLoading(false);
    }
  }, [onSaveSuccess, formStatus]);

  const onSubmit = (event: FormEvent<HTMLFormElement>) => {
    setIsLoading(true);
    event.preventDefault();
    const formData = checkFormValidation(event);
    if (typeof formData === 'object') {
      postFormData('/v1/resume/work-experience', formData);
    } else {
      setIsLoading(false);
    }
  };

  const { trigger } = useSwrResumeNoExperience(locale, noExpAction);


  return (
    <form noValidate onSubmit={onSubmit}>
      {/* inputs */}
      <ExperienceForm
        record={record}
        elementsRefs={elementsRefs}
        locale={locale}
      />
      <Label htmlFor="noExperience">
        <Input
          type="checkbox"
          onChange={() => { void trigger({ noExperience: true }); }}
          id="noExperience"
          name="noExperience"
        />
        <RadioText>{t('profile.wizard.no-experience.label')}</RadioText>
      </Label>
      {/* submit and skip buttons */}
      <FooterButtons
        submitType="submit"
        isLoading={isLoading}
      />
    </form>
  );
};
